import { Pipe, PipeTransform } from '@angular/core';

export interface SelectOption {
  label: string;
  value: string;
}

@Pipe({
  name: 'arrayToOptions',
})
export class ArrayToOptionsPipe implements PipeTransform {
  transform(value: string[] | null | undefined): SelectOption[] {
    if (!value || !Array.isArray(value)) {
      return [];
    }

    return value.map((item: string) => ({
      label: item,
      value: item,
    }));
  }
}
